import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './teStyle.css';
import config from '../../config.json';
import TimeEntryLabel from './TimeEntryLabel';

const apiUrl = config.apiUrl;

const TimeEntryDetails = () => {
    const [timeEntryDetails, setTimeEntryDetails] = useState({
        TransactionDate: '',
        Employee: [],
        StartDate: '',
        EndDate: '',
        Duration: '',
        EntryTypeID: '',
        Remarks: '',
        Status: '',
        CreatedBy: '',
        CreatedDate: '',
        UpdatedBy: '',
        UpdatedDate: '',
    });

    const { timeEntryId } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchTimeEntryData = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/TimeEntry/${timeEntryId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch time entry data');
                    setSuccessMessage('');
                    return;
                }
                const data = await response.json();
                setTimeEntryDetails({
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    StartDate: data.Details.StartDate,
                    EndDate: data.Details.EndDate,
                    Duration: data.Details.Duration,
                    EntryTypeID: data.Details.EntryTypeID,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                    CreatedBy: data.Details.CreatedBy,
                    CreatedDate: data.Details.CreatedDate,
                    UpdatedBy: data.Details.UpdatedBy,
                    UpdatedDate: data.Details.UpdatedDate,
                });
            } catch (error) {
                setErrorMessage('Error fetching time entry data');
                setSuccessMessage('');

            }
        };

        fetchTimeEntryData();
    }, []);

    const {
        TransactionDate,
        Employee,
        StartDate,
        EndDate,
        Duration,
        EntryTypeID,
        Remarks,
        Status,
        CreatedBy,
        CreatedDate,
        UpdatedBy,
        UpdatedDate,
    } = timeEntryDetails;

    return (
        <div>
            {userAccess.hasView ? (
                <>
                    <h3>View Time Entry</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <div className="row mt-4">
                        <TimeEntryLabel label="Transaction Date" value={TransactionDate} />
                        <TimeEntryLabel label="Employee" value={Employee.Name} />
                        <TimeEntryLabel label="Time In" value={StartDate} />
                        <TimeEntryLabel label="Time Out" value={EndDate} />
                        <TimeEntryLabel label="Duration" value={Duration} />
                        <TimeEntryLabel label="Entry Type" value={EntryTypeID} />
                        <TimeEntryLabel label="Remarks" value={Remarks} />
                        <TimeEntryLabel label="Status" value={Status} />
                        <TimeEntryLabel label="CreatedBy" value={CreatedBy} />
                        <TimeEntryLabel label="CreatedDate" value={CreatedDate} />
                        <TimeEntryLabel label="UpdatedBy" value={UpdatedBy} />
                        <TimeEntryLabel label="UpdatedDate" value={UpdatedDate} />

                        <div className="mb-2">
                            <Link to="/timeentry-list" className="btn btn-secondary">Back</Link>
                            {(userAccess.hasStandard || userAccess.hasAdmin) && (
                                <Link
                                    to={`/timeentry-update/${timeEntryId}`}
                                    className={`btn btn-primary ms-2 ${Status === 'Approved' || Status === 'Rejected' ? 'disabled' : ''}`}
                                >
                                    Edit
                                </Link>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default TimeEntryDetails;
